<template>
<v-card>
<v-app-bar
    app
    elevation="0"
    color="white"
    clipped-left
  >
  <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mobile" @click="drawer = true"></v-app-bar-nav-icon>
    <img
      height="100%"
      src="/images/amr_logo.png"
      alt="AMR Logo"
    />
    <v-btn
      class="ml-auto"
      text
      v-if="isAuthenticated"
      @click="logout"
      color="secondary"
    >
      Logout
      <v-icon
        right
      >
        mdi-logout
      </v-icon>
    </v-btn>
  </v-app-bar>
  <v-navigation-drawer
    app
    height="100vh"
    :permanent="!$vuetify.breakpoint.mobile"
    v-model="drawer"
    class="menu-list"
    color="secondary"
    clipped
  >
    <!-- menu -->
    <v-list nav>
      <v-list-item-group
        v-model="activeMenu"
        active-class="menu-list-item--active"
      >
        <v-list-item
          link
          class="menu-list-item"
          :exact="menuItem.isExact"
          :to="{ name: menuItem.name }"
          v-for="(menuItem, index) in menu"
          :key="index"
        >
          <v-list-item-content class="white--text">{{
            menuItem.title
          }}</v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <div class="blob">
      <img
        class="layer"
        src="/images/Vector.svg"
        alt=""
      >
      <img
        class="layer"
        src="/images/Vector-1.svg"
        alt=""
      >
      <img
        class="layer"
        src="/images/Vector-2.svg"
        alt=""
      >
    </div>
  </v-navigation-drawer>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from "@/store/modules/user";
import {ADMIN_MENU, NON_ADMIN_MENU} from '@/constants';
export default {
  name: "AppNavigation",
  data() {
    return {
      activeMenu: 0,
      drawer: false
    };
  },
  computed: {
    menu() {
      return this.isAdmin ? ADMIN_MENU : NON_ADMIN_MENU
    },
    ...mapGetters(['isAdmin', 'isAuthenticated'])
  },
  methods: {
    ...mapActions(["logout"]),
  },
};
</script>

<style scoped>
.v-list-item {
  min-height: 90px;
}
.layer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 20em;
  z-index: -1;
}

.menu-list-item--active {
  border-left: 4px solid #f8c02c;
}
</style>
